import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { firebaseConnect, isLoaded, isEmpty } from 'react-redux-firebase';
// import GoogleButton from 'react-google-button' // optional

export class UserButton extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      showUserMenu: false,
      firebase: this.props.firebase,
      auth: this.props.auth
    };
  }
  async componentWillReceiveProps(nextProps) {
    let showUserMenu = this.state.showUserMenu;
    let isApprover = false;
    if ((isLoaded(nextProps.auth)) && (!isEmpty(nextProps.auth))) {
      let userId = nextProps.firebase.auth().currentUser.uid;
      isApprover = await nextProps.firebase.database().ref('/approvers/' + userId).once('value').
        then(function (snapshot) {
          return (snapshot.val() !== null) && (snapshot.val() === true);
        });
    }
    this.setState({
      firebase: nextProps.firebase,
      auth: nextProps.auth,
      showUserMenu: (((isLoaded(nextProps.auth)) && (!isEmpty(nextProps.auth))) ?
        (showUserMenu) : (false)),
      isApprover: isApprover
    });
  }
  render() {
    let firebase = this.state.firebase,
      auth = this.state.auth;
    return (
      <div>
        {
          (this.state.showUserMenu) ?
            <div className="onhover-user-menu text-shadow text-white text-center"
              onMouseLeave={() => {
                this.setState({
                  showUserMenu: false
                });
              }}
            >
              <ul className="list-group list-group-flush">
                <li className="list-group-item overlay-container-background"
                  style={{ cursor: 'pointer' }}>
                  Add A Feature
                </li>
                <li className="list-group-item overlay-container-background"
                  style={{ cursor: 'pointer' }}>
                  <Link to='/bulkaddgeojson'>Bulk Add Features</Link>
                </li>
                {
                  (this.state.isApprover) ?
                    (
                      <li className="list-group-item overlay-container-background"
                        style={{ cursor: 'pointer' }}>
                        Approve Features
                      </li>
                    ) : null
                }
                <li className="list-group-item overlay-container-background"
                  style={{ cursor: 'pointer' }}>
                  <span onClick={() => {
                    firebase.auth().signOut().then(function () {
                    }, function (error) {
                    });
                  }}>
                    Logout
                  </span>
                </li>
              </ul>
            </div> :
            null
        }

      </div>
    );
  }
}

UserButton.propTypes = {
  firebase: PropTypes.shape({
    login: PropTypes.func.isRequired
  }),
  auth: PropTypes.object
};

export default compose(
  firebaseConnect(), // withFirebase can also be used
  connect(({ firebase: { auth } }) => ({ auth }))
)(UserButton)



// WEBPACK FOOTER //
// ./src/components/user/Button.js